<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">{{'COMMON.FIELD_AUDIT'| translate}}</h5>
        </div>
        <div class="modal-body text-center">
            <h3>{{'AUDIT_REVIEW_CUSTOMER.AUDIT' | translate}}</h3>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary cancel-button" #closeModal data-bs-dismiss="modal"
                aria-label="Close">
                <span>{{'COMMON.NO' | translate}}</span>
            </button>
            <button type="button" class="btn btn-primary btn-primary" (click)="submitAudit()">
                <span>{{'COMMON.YES' | translate}}</span>
            </button>
        </div>
    </div>
</div>